import YAML from 'yaml';

/**
 * The task YAML as viewer-api reads it. viewer-api parses an uploaded task with SnakeYAML, a YAML 1.1 parser:
 * there, a plain `yes`, `no`, `on`, `off`, `y` or `n` is a boolean, where the `yaml` package's default
 * (YAML 1.2) leaves them strings and writes them unquoted. So a copied task's `const: "yes"` came back as
 * `const: true`, under `type: string`, and its case could never be validated.
 *
 * Everything this page writes (the task sent, the file downloaded, the annotation and question editors)
 * and reads (an imported file, the editors) goes through YAML 1.1: the strings a 1.1 parser would read
 * as something else are quoted, and what the page shows is what viewer-api will read.
 *
 * Reading as YAML 1.1 also turns an unquoted `10:30` into the number 630 and `2026-12-01` into a date, as
 * SnakeYAML does on viewer-api: quote such values (`"10:30"`) when typing the YAML by hand.
 *
 * On the writing side, the `yaml` package leaves `_`, `_1` and `<<` unquoted even in YAML 1.1, where SnakeYAML reads
 * the first two as floats and `<<` as a merge key: should a task ever hold such a string, quote it.
 */
const VERSION = { version: '1.1' } as const;

export function stringifyTaskYaml(value: unknown): string {
  return YAML.stringify(value, { ...VERSION, lineWidth: 0 });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- as YAML.parse: the callers check the shape
export function parseTaskYaml(text: string): any {
  return YAML.parse(text, VERSION);
}

export function parseTaskYamlDocument(text: string) {
  return YAML.parseDocument(text, VERSION);
}
